<template>
	<div :class="['head-div', showInfoHead == 1 ? 'height3-7' : 'head0-6']">
		<div class="headNav" id="headNav">
			<!-- 20251216修改 -->
			<div class="home-btn" @click="pageToQyfw"><i class="el-icon-arrow-left"></i>返回主页</div>
			<div class="width-140 row justify-between items-center margin-a">
				<div class="fontStyle22 row  items-center font-bold">
					<img class="head-logo" src="../assets/homepage/logo.jpeg" alt="">
					武清区中小企业数字化转型公共服务平台
				</div>
				<!-- 195流程修改测试 -->
				<div class="fontStyle20 row menu-box ">
					<div class="head-menu" @click="pageTo(item)" :class="activeMenu == item.id ? 'headmenu-active' : ''"
						v-for="(item, index) in menuList" :key="index">
						{{ item.name }}
					</div>
				</div>
				<!-- 195流程修改测试over -->
				<div class="login-btn fontStyle18" @click="login" v-if="!userToken && $route.path != '/login'">登录/注册</div>
				<!-- <div class="login-btn fontStyle18" @click="backHome" v-if="!userToken && $route.path=='/login'">返回首页</div> -->

				<!-- <el-popover placement="bottom" width="1.5rem" trigger="click" v-if="userToken">
					<div>{{ mobile }}</div>
					<div>
						{{ userName }}（{{ userRole }}）
					</div>
					<el-divider class="divider-custom"></el-divider>
					<div class="work-desk" @click="getUserInfo"><i class="el-icon-s-platform" style="margin-right:0.05rem;"></i>工作台</div>
					<el-divider class="divider-custom"></el-divider>
					<div @click="logout" class="text-center cursor-pointer logout">退出登录</div>
					<div slot="reference" class="login-btn fontStyle18 webkit-line-1">{{ userName }}</div>
				</el-popover> -->
				<el-dropdown v-if="userToken">
					<div class="login-btn1 fontStyle16 webkit-line-1">
						<img src="../assets/homepage/avatar.png" alt="">
						<span>{{ userName }}</span>
					</div>
					<el-dropdown-menu slot="dropdown">
						<!-- <el-dropdown-item>{{ userRole }}</el-dropdown-item> -->
						<el-dropdown-item @click.native="getUserInfo">工作台</el-dropdown-item>
						<el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>

			</div>
		</div>
		<div class="headNav-mobile">
			<div class="width-140 row justify-between items-center margin-a">
				<div class="fontStyle22 row  items-center font-bold">
					<img class="head-logo" src="../assets/homepage/logo.jpeg" alt="">
					武清区中小企业数字化转型公共服务平台
				</div>
				<i class="el-icon-menu fontStyle22" @click="showMenu"></i>
			</div>
		</div>
		<el-drawer title="武清区中小企业数字化转型公共服务平台" direction="ltr" :visible.sync="menuDrawer" :with-header="false">
			<!-- 20251216修改 -->
			<div class="head-menu-mobile fontStyle22" @click="pageToQyfw"
				:class="activeMenu == 0 ? 'headmenu-active' : ''" >
				返回主页
			</div>
			<div class="head-menu-mobile fontStyle22" @click="pageTo(item)"
				:class="activeMenu == item.id ? 'headmenu-active' : ''" v-for="(item, index) in menuList" :key="index">
				{{ item.name }}
			</div>
			<div class="head-menu-mobile fontStyle22" @click="loginTip"> 登录/注册 </div>
		</el-drawer>
		<div v-if="showInfoHead == 1" class="info-head fontStyle48">
			<span :class="!showTitle?'pc-hide':''">{{!showTitle?'武清区中小企业数字化转型公共服务平台':showTitle}}</span>
		</div>
		<div class="mask" v-if="maskShow" @click="maskShow = false">
			<div class="login-dialog row items-center">
				<div class="login-dialog-item" v-for="(item, index) in loginItem" :key="index"
					@click.stop="loginItemClick(item)">
					<div class="fontStyle36 item-name" :class="index==3?'item-name3':''" v-html="item.name"></div>
					<img class="divider-img" src="../assets/homepage/divider-img.png" alt="">
					<img class="item-png" :src="item.img" :style="{ 'width': item.width, 'height': item.height }" alt="">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Cookies from "js-cookie";
export default {
	data() {
		return {
			maskShow: false,
			menuDrawer: false,
			// activeMenu: '1',
			menuList: [
				{
					name: '首页',
					id: '1',
					//20251216修改
					// path: '/home'
					path: '/'
				},
				{
					name: '政策服务',
					id: '2',
					// path: '/'
					path: '/policy'
				},
				{
					name: '供应大厅',
					id: '3',
					path: '/supplyHall'
					// path: '/'
				},
				// {
				// 	name: '增值服务',
				// 	id: '4',
				// 	// path:'/services'
				// 	path: '/'
				// 	// path: '/home'
				// 	// 195流程修改测试
				// },
				{
					name: '资讯中心',
					id: '5',
					// path:'/consulteCenter'
					path: '/newsCenter'
					// path: '/'
					// 195流程修改测试
				},
				{
					name: '培训教学',
					id: '6',
					// path:'/consulteCenter'
					path: 'https://amtbs.cn:9999/splb/'
					// path: '/'
				},
			],
			loginItem: [
				{
					name: '试点企业',
					img: require('../assets/homepage/sdqy-icon.png'),
					width: '1.2rem',
					height: '1rem',
					accountType: '1',
				},
				{
					name: '服务商',
					img: require('../assets/homepage/fws-icon.png'),
					width: '1.06rem',
					height: '0.9rem',
					accountType: '2',
				},
				{
					name: '评测机构',
					img: require('../assets/homepage/zzjg-icon.png'),
					width: '0.95rem',
					height: '0.9rem',
					accountType: '3',
				},
				{
					name: '全流程<br>综合服务<br>机构',
					img: require('../assets/homepage/zjzz-icon.png'),
					width: '0.9rem',
					height: '1rem',
					accountType: '4',
				},
				{
					name: '政府专班',
					img: require('../assets/homepage/zfzb-icon.png'),
					width: '0.87rem',
					height: '0.92rem',
					accountType: '5',
				},
			],
			userToken: Cookies.get("token"),
			userName: Cookies.get('userInfo') ?
				JSON.parse(Cookies.get('userInfo')).type == 1 || JSON.parse(Cookies.get('userInfo')).type == 2 ?
					JSON.parse(Cookies.get('userInfo')).enterpriseDTO.enterpriseName :JSON.parse(Cookies.get('userInfo')).type == 3?'评测机构': JSON.parse(Cookies.get('userInfo')).type == 4 ? '监理机构' : '政府专班' : '',
			mobile: Cookies.get('userInfo') ?
				JSON.parse(Cookies.get('userInfo')).type == 1 || JSON.parse(Cookies.get('userInfo')).type == 2 || JSON.parse(Cookies.get('userInfo')).type == 3 ?
					JSON.parse(Cookies.get('userInfo')).mobile :JSON.parse(Cookies.get('userInfo')).type == 3?'评测机构': JSON.parse(Cookies.get('userInfo')).type == 4 ? '监理机构' : '政府专班' : '',
			userRole: Cookies.get('userInfo') ?
				JSON.parse(Cookies.get('userInfo')).type == 1 ? '试点企业' : JSON.parse(Cookies.get('userInfo')).type == 2 ? '服务商' : JSON.parse(Cookies.get('userInfo')).type == 3 ? '评测机构' : JSON.parse(Cookies.get('userInfo')).type == 4 ? '监理机构' : '政府专班' : '',
		}
	},
	props: ['showInfoHead', 'activeMenu','showTitle'],
	methods: {
		showMenu() {
			console.log(123)
			this.menuDrawer = true
		},
		loginItemClick(item) {
			this.maskShow = false
			this.$router.push({
				path: '/login',
				name: 'login',
				query: {
					type: 1
				},
				params: {
					accountType: item.accountType
				}
			})
		},
		pageTo(item) {
			// this.activeMenu = item.id
			// if(item.id == '5'){
			// 	this.$message.warning('功能开发中，敬请期待')
			// }else{
			// debugger
			if (item.id == 6 ) {
				window.open(item.path,'_blank')
			}else if(item.id == 0){
				window.location.href = item.path
			} else {
				this.$router.push(item.path)
			}
			// }
		},
		pageToQyfw(){
			window.location.href = this.$url.gxjUrl
		},
		login() {
			// 195流程修改测试
			// 跳转到新登录
			// this.$router.replace({
			// 	path: '/'
			// })
			this.maskShow = true
			// // this.$router.push({
			// // 	path: '/login',
			// // 	query: {
			// // 		type: 1
			// // 	}
			// // })
		},
		backHome() {
			this.$router.push({
				path: '/',
			})
		},
		register() {
			this.$router.push({
				path: '/login',
				query: {
					type: 2
				}
			})
		},
		loginTip(){
			this.$alert('请使用电脑端登录注册', '温馨提示', {
          confirmButtonText: '确定',
          callback: action => {
            
          }
        });
		},
		logout() {
			this.$confirm("确定退出?", "提示", {
				confirmButtonText: "确认",
				cancelButtonText: "取消",
				type: "warning",
			}).then(() => {
				Cookies.remove('token')
				Cookies.remove('userInfo')
				// sessionStorage.clear();
				window.localStorage.clear()
				localStorage.setItem('source', 'wqqyfw')
				// 20251216修改
				if(this.$route.path == '/'){
					location.reload()
				}else{
					this.$router.replace({ path: '/', query: { source: 'wqqyfw' } })
				}
			})
		},
		getUserInfo() {
			this.$router.push('/personalCenter')
		}
	}
} 
</script>

<style scoped>
@import "../assets/font/font.css";

.headNav {
	width: 100%;
	height: 0.6rem;
	line-height: 0.6rem;
	background: rgba(255, 255, 255, 0.8);
	position: relative;
	z-index: 1;
}
.home-btn{
	cursor: pointer;
	font-size: 0.12rem;
	position: absolute;
	left: 0.1rem;
	top: 50%;
	transform: translateY(-50%);
	height: 0.3rem;
	line-height: 0.3rem;
	border-radius: 4px;
	color: #fff;
	padding: 0 0.1rem;
	background:linear-gradient(90deg, #0269FF 0%, #1D99FF 100%);
}
.home-btn:hover{
	background:linear-gradient(90deg, #1D99FF 0%, #1dddff 100%);

}
.headNav-mobile {
	display: none;
}

.head-logo {
	width: 0.73rem;
	height: 0.52rem;
	margin-right: 0.2rem;
}

.menu-box {
	margin-left: 0.5rem;
}

.login-btn {
	width: 1rem;
	height: 0.4rem;
	line-height: 0.4rem;
	text-align: center;
	border-radius: 8px;
	color: #fff;
	/* margin-left: 0.57rem; */
	background: linear-gradient(270deg, #0269FF 0%, #1D99FF 100%);
	box-shadow: 0px 2px 6px 0px rgba(9, 11, 49, 0.1804);
	cursor: pointer;
	padding: 0 0.1rem;
}
.login-btn:hover{
	background:linear-gradient(90deg, #1D99FF 0%, #1dddff 100%);
}
.login-btn1 {
	width: 1rem;
	height: 0.4rem;
	line-height: 0.4rem;
	text-align: center;
	border-radius: 8px;
	color: #000;

	cursor: pointer;
	padding: 0 0.1rem;
}

.login-btn1 img {
	width: 0.3rem;
	vertical-align: middle;
}

.login-btn1 span {
	vertical-align: middle;
}

.head-menu {
	color: #363636;
	margin-right: 0.3rem;
	width: 1rem;
	text-align: center;
}

.head-menu:hover {
	font-size: 0.24rem;
	font-family: 'albbphb';
	cursor: pointer;
	font-weight: bold;
}

.headmenu-active {
	font-size: 0.22rem;
	font-family: 'albbphb';
	color: #1893ff;
	font-weight: bold;
}

.head-div {
	position: relative;
}

.height3-7 {
	height: 3.7rem;
}


.info-head {
	background: url(../assets/homepage/infobanner.png);
	background-size: 100% 100%;
	width: 100%;
	height: 3.7rem;
	position: absolute;
	top: 0;
	text-shadow: 2.76px 9.61px 0px #D5E4FF;
	text-align: center;
	line-height: 3.7rem;
	font-weight: bold;
}

.divider-custom {
	margin: 0.1rem 0;
}

.logout {
	background: #f8f9fc;
	padding: 0.05rem 0;
	border-radius: 4px;
}

.logout:hover {
	background: #2468f10f;
	color: #1893ff;
}

.work-desk {
	cursor: pointer;
}

.work-desk:hover {
	color: #1893ff
}

.mask {
	width: 100vw;
	height: 100vh;
	background: rgba(0, 0, 0, 0.5);
	position: fixed;
	top: 0;
	left: 0;
	z-index: 11;
}

.login-dialog {
	background: url(../assets/homepage/logindiabg.png);
	background-size: 100% 100%;
	width: 14.5rem;
	height: 5rem;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	justify-content: center;
}

.login-dialog-item {
	width: 2.6rem;
	height: 3.6rem;
	background: url(../assets/homepage/logindiaitem.png);
	background-size: 100% 100%;
	position: relative;
	cursor: pointer;
	transition: all 0.5s;
}

.login-dialog-item:hover {
	background: url(../assets/homepage/logindiaitem-active.png);
	background-size: 100% 100%;
	margin-top: -0.5rem;
}

.item-name {
	margin-top: 0.6rem;
	text-align: center;
	color: #296BE5;
}
.item-name2{
	margin-top: 0.4rem;
}
.item-name3{
	margin-top: 0.4rem;
	font-size: 0.28rem;
}
.item-png {
	position: absolute;
	right: 0.5rem;
	bottom: 0.8rem;
}

.divider-img {
	position: absolute;
	width: 1rem;
	left: 50%;
	transform: translateX(-50%);
	margin-top: 0.15rem;
}

/* 屏幕小于1200 */
@media only screen and (max-width: 767px) {
	.headNav {
		display: none;
	}

	.headNav-mobile {
		display: block;
		height: 0.9rem;
		line-height: 0.9rem;
		position: relative;
    z-index: 1;
		background: #fff;
	}

	.head-menu-mobile {
		margin-bottom: 10px;
		padding: 10px;
	}

	.headmenu-active {
		font-size: 0.28rem;
		font-weight: bold;
	}
	.pc-hide{
		display: none;
	}

}
</style>